export const PAGE_SIZE = 15;
export const PARTNERS_PAGE_SIZE = 16;

export const VALID_US_CITIES = [
  "Los Angeles",
  "New York",
  "Miami",
  "San Diego",
];

export const CITY_CONSTANTS = {
  LOS_ANGELES: "LOS_ANGELES",
  NEW_YORK: "NEW_YORK",
  MIAMI: "MIAMI",
  ALL: "ALL",
  LONDON: "LONDON",
  SAN_DIEGO: "SAN_DIEGO",
};

// Маппинг для UI -> бэкенд
export const CITY_MAPPING = {
  "Los Angeles": CITY_CONSTANTS.LOS_ANGELES,
  "New York": CITY_CONSTANTS.NEW_YORK,
  Miami: CITY_CONSTANTS.MIAMI,
  London: CITY_CONSTANTS.LONDON,
};

// Обратный маппинг для бэкенд -> UI (если нужно)
export const reverseMapping = {
  [CITY_CONSTANTS.LOS_ANGELES]: "Los Angeles",
  [CITY_CONSTANTS.NEW_YORK]: "New York",
  [CITY_CONSTANTS.MIAMI]: "Miami",
  [CITY_CONSTANTS.SAN_DIEGO]: "San Diego",
  [CITY_CONSTANTS.LONDON]: "London",
};

export const phoneNumbers = {
  US: {
    phoneCode: "+1",
    phoneNumber: "3233872101",
    nationalNumber: "3233872101",
    nationalNumberFormatted: "(323) 387 2101",
    internationalNumber: "+13233872101",
  },
  GB: {
    phoneCode: "+44",
    phoneNumber: "7459783573",
    nationalNumber: "07459783573",
    internationalNumber: "+447459783573",
    nationalNumberFormatted: "(0) 745 978 3573",
    internationalNumberFormatted: "+44 745 978 3573",
  },
  US_redirect: {
    phoneCode: "+1",
    phoneNumber: "2098626606",
    nationalNumber: "2098626606",
    internationalNumber: "+12098626606",
    nationalNumberFormatted: "(209)862-6606",
    internationalNumberFormatted: "+1 (209)862-6606",
  },
};

export const COUNTRY_PHONE_CODES_WITH_FLAGS = [
  {
    name: "Afghanistan",
    emoji: "🇦🇫",
    unicode: "U+1F1E6 U+1F1EB",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AF.svg",
    code: "AF",
    phoneCode: "+93",
  },
  {
    name: "Albania",
    emoji: "🇦🇱",
    unicode: "U+1F1E6 U+1F1F1",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AL.svg",
    code: "AL",
    phoneCode: "+355",
  },
  {
    name: "Algeria",
    emoji: "🇩🇿",
    unicode: "U+1F1E9 U+1F1FF",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DZ.svg",
    code: "DZ",
    phoneCode: "+213",
  },
  {
    name: "American Samoa",
    emoji: "🇦🇸",
    unicode: "U+1F1E6 U+1F1F8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AS.svg",
    code: "AS",
    phoneCode: "+1 684",
  },
  {
    name: "Andorra",
    emoji: "🇦🇩",
    unicode: "U+1F1E6 U+1F1E9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AD.svg",
    code: "AD",
    phoneCode: "+376",
  },
  {
    name: "Angola",
    emoji: "🇦🇴",
    unicode: "U+1F1E6 U+1F1F4",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AO.svg",
    code: "AO",
    phoneCode: "+244",
  },
  {
    name: "Anguilla",
    emoji: "🇦🇮",
    unicode: "U+1F1E6 U+1F1EE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AI.svg",
    code: "AI",
    phoneCode: "+1 264",
  },
  {
    name: "Argentina",
    emoji: "🇦🇷",
    unicode: "U+1F1E6 U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AR.svg",
    code: "AR",
    phoneCode: "+54",
  },
  {
    name: "Armenia",
    emoji: "🇦🇲",
    unicode: "U+1F1E6 U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AM.svg",
    code: "AM",
    phoneCode: "+374",
  },
  {
    name: "Aruba",
    emoji: "🇦🇼",
    unicode: "U+1F1E6 U+1F1FC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AW.svg",
    code: "AW",
    phoneCode: "+297",
  },
  {
    name: "Australia",
    emoji: "🇦🇺",
    unicode: "U+1F1E6 U+1F1FA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AU.svg",
    code: "AU",
    phoneCode: "+61",
  },
  {
    name: "Austria",
    emoji: "🇦🇹",
    unicode: "U+1F1E6 U+1F1F9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AT.svg",
    code: "AT",
    phoneCode: "+43",
  },
  {
    name: "Azerbaijan",
    emoji: "🇦🇿",
    unicode: "U+1F1E6 U+1F1FF",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AZ.svg",
    code: "AZ",
    phoneCode: "+994",
  },
  {
    name: "Bahamas",
    emoji: "🇧🇸",
    unicode: "U+1F1E7 U+1F1F8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BS.svg",
    code: "BS",
    phoneCode: "+1 242",
  },
  {
    name: "Bahrain",
    emoji: "🇧🇭",
    unicode: "U+1F1E7 U+1F1ED",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BH.svg",
    code: "BH",
    phoneCode: "+973",
  },
  {
    name: "Bangladesh",
    emoji: "🇧🇩",
    unicode: "U+1F1E7 U+1F1E9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BD.svg",
    code: "BD",
    phoneCode: "+880",
  },
  {
    name: "Barbados",
    emoji: "🇧🇧",
    unicode: "U+1F1E7 U+1F1E7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BB.svg",
    code: "BB",
    phoneCode: "+1 246",
  },
  {
    name: "Belarus",
    emoji: "🇧🇾",
    unicode: "U+1F1E7 U+1F1FE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BY.svg",
    code: "BY",
    phoneCode: "+375",
  },
  {
    name: "Belgium",
    emoji: "🇧🇪",
    unicode: "U+1F1E7 U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BE.svg",
    code: "BE",
    phoneCode: "+32",
  },
  {
    name: "Belize",
    emoji: "🇧🇿",
    unicode: "U+1F1E7 U+1F1FF",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BZ.svg",
    code: "BZ",
    phoneCode: "+501",
  },
  {
    name: "Benin",
    emoji: "🇧🇯",
    unicode: "U+1F1E7 U+1F1EF",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BJ.svg",
    code: "BJ",
    phoneCode: "+229",
  },
  {
    name: "Bermuda",
    emoji: "🇧🇲",
    unicode: "U+1F1E7 U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BM.svg",
    code: "BM",
    phoneCode: "+1 441",
  },
  {
    name: "Bhutan",
    emoji: "🇧🇹",
    unicode: "U+1F1E7 U+1F1F9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BT.svg",
    code: "BT",
    phoneCode: "+975",
  },
  {
    name: "Bolivia",
    emoji: "🇧🇴",
    unicode: "U+1F1E7 U+1F1F4",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BO.svg",
    code: "BO",
    phoneCode: "+591",
  },
  {
    name: "Botswana",
    emoji: "🇧🇼",
    unicode: "U+1F1E7 U+1F1FC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BW.svg",
    code: "BW",
    phoneCode: "+267",
  },
  {
    name: "Brazil",
    emoji: "🇧🇷",
    unicode: "U+1F1E7 U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BR.svg",
    code: "BR",
    phoneCode: "+55",
  },
  {
    name: "British Indian Ocean Territory",
    emoji: "🇮🇴",
    unicode: "U+1F1EE U+1F1F4",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IO.svg",
    code: "IO",
    phoneCode: "+246",
  },
  {
    name: "British Virgin Islands",
    emoji: "🇻🇬",
    unicode: "U+1F1FB U+1F1EC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VG.svg",
    code: "VG",
    phoneCode: "+1 284",
  },
  {
    name: "Brunei",
    emoji: "🇧🇳",
    unicode: "U+1F1E7 U+1F1F3",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BN.svg",
    code: "BN",
    phoneCode: "+673",
  },
  {
    name: "Bulgaria",
    emoji: "🇧🇬",
    unicode: "U+1F1E7 U+1F1EC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BG.svg",
    code: "BG",
    phoneCode: "+359",
  },
  {
    name: "Burkina Faso",
    emoji: "🇧🇫",
    unicode: "U+1F1E7 U+1F1EB",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BF.svg",
    code: "BF",
    phoneCode: "+226",
  },
  {
    name: "Burundi",
    emoji: "🇧🇮",
    unicode: "U+1F1E7 U+1F1EE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BI.svg",
    code: "BI",
    phoneCode: "+257",
  },
  {
    name: "Cambodia",
    emoji: "🇰🇭",
    unicode: "U+1F1F0 U+1F1ED",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KH.svg",
    code: "KH",
    phoneCode: "+855",
  },
  {
    name: "Cameroon",
    emoji: "🇨🇲",
    unicode: "U+1F1E8 U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CM.svg",
    code: "CM",
    phoneCode: "+237",
  },
  {
    name: "Canada",
    emoji: "🇨🇦",
    unicode: "U+1F1E8 U+1F1E6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CA.svg",
    code: "CA",
    phoneCode: "+1",
  },
  {
    name: "Cape Verde",
    emoji: "🇨🇻",
    unicode: "U+1F1E8 U+1F1FB",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CV.svg",
    code: "CV",
    phoneCode: "+238",
  },
  {
    name: "Cayman Islands",
    emoji: "🇰🇾",
    unicode: "U+1F1F0 U+1F1FE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KY.svg",
    code: "KY",
    phoneCode: "+ 345",
  },
  {
    name: "Central African Republic",
    emoji: "🇨🇫",
    unicode: "U+1F1E8 U+1F1EB",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CF.svg",
    code: "CF",
    phoneCode: "+236",
  },
  {
    name: "Chad",
    emoji: "🇹🇩",
    unicode: "U+1F1F9 U+1F1E9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TD.svg",
    code: "TD",
    phoneCode: "+235",
  },
  {
    name: "Chile",
    emoji: "🇨🇱",
    unicode: "U+1F1E8 U+1F1F1",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CL.svg",
    code: "CL",
    phoneCode: "+56",
  },
  {
    name: "China",
    emoji: "🇨🇳",
    unicode: "U+1F1E8 U+1F1F3",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CN.svg",
    code: "CN",
    phoneCode: "+86",
  },
  {
    name: "Christmas Island",
    emoji: "🇨🇽",
    unicode: "U+1F1E8 U+1F1FD",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CX.svg",
    code: "CX",
    phoneCode: "+61",
  },
  {
    name: "Colombia",
    emoji: "🇨🇴",
    unicode: "U+1F1E8 U+1F1F4",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CO.svg",
    code: "CO",
    phoneCode: "+57",
  },
  {
    name: "Comoros",
    emoji: "🇰🇲",
    unicode: "U+1F1F0 U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KM.svg",
    code: "KM",
    phoneCode: "+269",
  },
  {
    name: "Cook Islands",
    emoji: "🇨🇰",
    unicode: "U+1F1E8 U+1F1F0",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CK.svg",
    code: "CK",
    phoneCode: "+682",
  },
  {
    name: "Costa Rica",
    emoji: "🇨🇷",
    unicode: "U+1F1E8 U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CR.svg",
    code: "CR",
    phoneCode: "+506",
  },
  {
    name: "Croatia",
    emoji: "🇭🇷",
    unicode: "U+1F1ED U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HR.svg",
    code: "HR",
    phoneCode: "+385",
  },
  {
    name: "Cuba",
    emoji: "🇨🇺",
    unicode: "U+1F1E8 U+1F1FA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CU.svg",
    code: "CU",
    phoneCode: "+53",
  },
  {
    name: "Cyprus",
    emoji: "🇨🇾",
    unicode: "U+1F1E8 U+1F1FE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CY.svg",
    code: "CY",
    phoneCode: "+537",
  },
  {
    name: "Denmark",
    emoji: "🇩🇰",
    unicode: "U+1F1E9 U+1F1F0",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DK.svg",
    code: "DK",
    phoneCode: "+45",
  },
  {
    name: "Diego Garcia",
    emoji: "🇩🇬",
    unicode: "U+1F1E9 U+1F1EC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DG.svg",
    code: "DG",
    phoneCode: "+246",
  },
  {
    name: "Djibouti",
    emoji: "🇩🇯",
    unicode: "U+1F1E9 U+1F1EF",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DJ.svg",
    code: "DJ",
    phoneCode: "+253",
  },
  {
    name: "Dominica",
    emoji: "🇩🇲",
    unicode: "U+1F1E9 U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DM.svg",
    code: "DM",
    phoneCode: "+1 767",
  },
  {
    name: "Dominican Republic",
    emoji: "🇩🇴",
    unicode: "U+1F1E9 U+1F1F4",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DO.svg",
    code: "DO",
    phoneCode: "+1 809",
  },
  {
    name: "Ecuador",
    emoji: "🇪🇨",
    unicode: "U+1F1EA U+1F1E8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EC.svg",
    code: "EC",
    phoneCode: "+593",
  },
  {
    name: "Egypt",
    emoji: "🇪🇬",
    unicode: "U+1F1EA U+1F1EC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EG.svg",
    code: "EG",
    phoneCode: "+20",
  },
  {
    name: "El Salvador",
    emoji: "🇸🇻",
    unicode: "U+1F1F8 U+1F1FB",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SV.svg",
    code: "SV",
    phoneCode: "+503",
  },
  {
    name: "Equatorial Guinea",
    emoji: "🇬🇶",
    unicode: "U+1F1EC U+1F1F6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GQ.svg",
    code: "GQ",
    phoneCode: "+240",
  },
  {
    name: "Eritrea",
    emoji: "🇪🇷",
    unicode: "U+1F1EA U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ER.svg",
    code: "ER",
    phoneCode: "+291",
  },
  {
    name: "Estonia",
    emoji: "🇪🇪",
    unicode: "U+1F1EA U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EE.svg",
    code: "EE",
    phoneCode: "+372",
  },
  {
    name: "Ethiopia",
    emoji: "🇪🇹",
    unicode: "U+1F1EA U+1F1F9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ET.svg",
    code: "ET",
    phoneCode: "+251",
  },
  {
    name: "Falkland Islands",
    emoji: "🇫🇰",
    unicode: "U+1F1EB U+1F1F0",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FK.svg",
    code: "FK",
    phoneCode: "+500",
  },
  {
    name: "Faroe Islands",
    emoji: "🇫🇴",
    unicode: "U+1F1EB U+1F1F4",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FO.svg",
    code: "FO",
    phoneCode: "+298",
  },
  {
    name: "Fiji",
    emoji: "🇫🇯",
    unicode: "U+1F1EB U+1F1EF",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FJ.svg",
    code: "FJ",
    phoneCode: "+679",
  },
  {
    name: "Finland",
    emoji: "🇫🇮",
    unicode: "U+1F1EB U+1F1EE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FI.svg",
    code: "FI",
    phoneCode: "+358",
  },
  {
    name: "France",
    emoji: "🇫🇷",
    unicode: "U+1F1EB U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FR.svg",
    code: "FR",
    phoneCode: "+33",
  },
  {
    name: "French Guiana",
    emoji: "🇬🇫",
    unicode: "U+1F1EC U+1F1EB",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GF.svg",
    code: "GF",
    phoneCode: "+594",
  },
  {
    name: "French Polynesia",
    emoji: "🇵🇫",
    unicode: "U+1F1F5 U+1F1EB",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PF.svg",
    code: "PF",
    phoneCode: "+689",
  },
  {
    name: "Gabon",
    emoji: "🇬🇦",
    unicode: "U+1F1EC U+1F1E6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GA.svg",
    code: "GA",
    phoneCode: "+241",
  },
  {
    name: "Gambia",
    emoji: "🇬🇲",
    unicode: "U+1F1EC U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GM.svg",
    code: "GM",
    phoneCode: "+220",
  },
  {
    name: "Georgia",
    emoji: "🇬🇪",
    unicode: "U+1F1EC U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GE.svg",
    code: "GE",
    phoneCode: "+995",
  },
  {
    name: "Germany",
    emoji: "🇩🇪",
    unicode: "U+1F1E9 U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DE.svg",
    code: "DE",
    phoneCode: "+49",
  },
  {
    name: "Ghana",
    emoji: "🇬🇭",
    unicode: "U+1F1EC U+1F1ED",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GH.svg",
    code: "GH",
    phoneCode: "+233",
  },
  {
    name: "Gibraltar",
    emoji: "🇬🇮",
    unicode: "U+1F1EC U+1F1EE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GI.svg",
    code: "GI",
    phoneCode: "+350",
  },
  {
    name: "Greece",
    emoji: "🇬🇷",
    unicode: "U+1F1EC U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GR.svg",
    code: "GR",
    phoneCode: "+30",
  },
  {
    name: "Greenland",
    emoji: "🇬🇱",
    unicode: "U+1F1EC U+1F1F1",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GL.svg",
    code: "GL",
    phoneCode: "+299",
  },
  {
    name: "Grenada",
    emoji: "🇬🇩",
    unicode: "U+1F1EC U+1F1E9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GD.svg",
    code: "GD",
    phoneCode: "+1 473",
  },
  {
    name: "Guadeloupe",
    emoji: "🇬🇵",
    unicode: "U+1F1EC U+1F1F5",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GP.svg",
    code: "GP",
    phoneCode: "+590",
  },
  {
    name: "Guam",
    emoji: "🇬🇺",
    unicode: "U+1F1EC U+1F1FA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GU.svg",
    code: "GU",
    phoneCode: "+1 671",
  },
  {
    name: "Guatemala",
    emoji: "🇬🇹",
    unicode: "U+1F1EC U+1F1F9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GT.svg",
    code: "GT",
    phoneCode: "+502",
  },
  {
    name: "Guinea",
    emoji: "🇬🇳",
    unicode: "U+1F1EC U+1F1F3",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GN.svg",
    code: "GN",
    phoneCode: "+224",
  },
  {
    name: "Guinea-Bissau",
    emoji: "🇬🇼",
    unicode: "U+1F1EC U+1F1FC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GW.svg",
    code: "GW",
    phoneCode: "+245",
  },
  {
    name: "Guyana",
    emoji: "🇬🇾",
    unicode: "U+1F1EC U+1F1FE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GY.svg",
    code: "GY",
    phoneCode: "+595",
  },
  {
    name: "Haiti",
    emoji: "🇭🇹",
    unicode: "U+1F1ED U+1F1F9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HT.svg",
    code: "HT",
    phoneCode: "+509",
  },
  {
    name: "Honduras",
    emoji: "🇭🇳",
    unicode: "U+1F1ED U+1F1F3",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HN.svg",
    code: "HN",
    phoneCode: "+504",
  },
  {
    name: "Hong Kong SAR China",
    emoji: "🇭🇰",
    unicode: "U+1F1ED U+1F1F0",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HK.svg",
    code: "HK",
    phoneCode: "+852",
  },
  {
    name: "Hungary",
    emoji: "🇭🇺",
    unicode: "U+1F1ED U+1F1FA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HU.svg",
    code: "HU",
    phoneCode: "+36",
  },
  {
    name: "Iceland",
    emoji: "🇮🇸",
    unicode: "U+1F1EE U+1F1F8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IS.svg",
    code: "IS",
    phoneCode: "+354",
  },
  {
    name: "India",
    emoji: "🇮🇳",
    unicode: "U+1F1EE U+1F1F3",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg",
    code: "IN",
    phoneCode: "+91",
  },
  {
    name: "Indonesia",
    emoji: "🇮🇩",
    unicode: "U+1F1EE U+1F1E9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ID.svg",
    code: "ID",
    phoneCode: "+62",
  },
  {
    name: "Iran",
    emoji: "🇮🇷",
    unicode: "U+1F1EE U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IR.svg",
    code: "IR",
    phoneCode: "+98",
  },
  {
    name: "Iraq",
    emoji: "🇮🇶",
    unicode: "U+1F1EE U+1F1F6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IQ.svg",
    code: "IQ",
    phoneCode: "+964",
  },
  {
    name: "Ireland",
    emoji: "🇮🇪",
    unicode: "U+1F1EE U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IE.svg",
    code: "IE",
    phoneCode: "+353",
  },
  {
    name: "Israel",
    emoji: "🇮🇱",
    unicode: "U+1F1EE U+1F1F1",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IL.svg",
    code: "IL",
    phoneCode: "+972",
  },
  {
    name: "Italy",
    emoji: "🇮🇹",
    unicode: "U+1F1EE U+1F1F9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IT.svg",
    code: "IT",
    phoneCode: "+39",
  },
  {
    name: "Jamaica",
    emoji: "🇯🇲",
    unicode: "U+1F1EF U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JM.svg",
    code: "JM",
    phoneCode: "+1 876",
  },
  {
    name: "Japan",
    emoji: "🇯🇵",
    unicode: "U+1F1EF U+1F1F5",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JP.svg",
    code: "JP",
    phoneCode: "+81",
  },
  {
    name: "Jordan",
    emoji: "🇯🇴",
    unicode: "U+1F1EF U+1F1F4",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JO.svg",
    code: "JO",
    phoneCode: "+962",
  },
  {
    name: "Kazakhstan",
    emoji: "🇰🇿",
    unicode: "U+1F1F0 U+1F1FF",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KZ.svg",
    code: "KZ",
    phoneCode: "+7 7",
  },
  {
    name: "Kenya",
    emoji: "🇰🇪",
    unicode: "U+1F1F0 U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KE.svg",
    code: "KE",
    phoneCode: "+254",
  },
  {
    name: "Kiribati",
    emoji: "🇰🇮",
    unicode: "U+1F1F0 U+1F1EE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KI.svg",
    code: "KI",
    phoneCode: "+686",
  },
  {
    name: "Kuwait",
    emoji: "🇰🇼",
    unicode: "U+1F1F0 U+1F1FC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KW.svg",
    code: "KW",
    phoneCode: "+965",
  },
  {
    name: "Kyrgyzstan",
    emoji: "🇰🇬",
    unicode: "U+1F1F0 U+1F1EC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KG.svg",
    code: "KG",
    phoneCode: "+996",
  },
  {
    name: "Laos",
    emoji: "🇱🇦",
    unicode: "U+1F1F1 U+1F1E6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LA.svg",
    code: "LA",
    phoneCode: "+856",
  },
  {
    name: "Latvia",
    emoji: "🇱🇻",
    unicode: "U+1F1F1 U+1F1FB",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LV.svg",
    code: "LV",
    phoneCode: "+371",
  },
  {
    name: "Lebanon",
    emoji: "🇱🇧",
    unicode: "U+1F1F1 U+1F1E7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LB.svg",
    code: "LB",
    phoneCode: "+961",
  },
  {
    name: "Lesotho",
    emoji: "🇱🇸",
    unicode: "U+1F1F1 U+1F1F8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LS.svg",
    code: "LS",
    phoneCode: "+266",
  },
  {
    name: "Liberia",
    emoji: "🇱🇷",
    unicode: "U+1F1F1 U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LR.svg",
    code: "LR",
    phoneCode: "+231",
  },
  {
    name: "Libya",
    emoji: "🇱🇾",
    unicode: "U+1F1F1 U+1F1FE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LY.svg",
    code: "LY",
    phoneCode: "+218",
  },
  {
    name: "Liechtenstein",
    emoji: "🇱🇮",
    unicode: "U+1F1F1 U+1F1EE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LI.svg",
    code: "LI",
    phoneCode: "+423",
  },
  {
    name: "Lithuania",
    emoji: "🇱🇹",
    unicode: "U+1F1F1 U+1F1F9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LT.svg",
    code: "LT",
    phoneCode: "+370",
  },
  {
    name: "Luxembourg",
    emoji: "🇱🇺",
    unicode: "U+1F1F1 U+1F1FA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LU.svg",
    code: "LU",
    phoneCode: "+352",
  },
  {
    name: "Madagascar",
    emoji: "🇲🇬",
    unicode: "U+1F1F2 U+1F1EC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MG.svg",
    code: "MG",
    phoneCode: "+261",
  },
  {
    name: "Malawi",
    emoji: "🇲🇼",
    unicode: "U+1F1F2 U+1F1FC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MW.svg",
    code: "MW",
    phoneCode: "+265",
  },
  {
    name: "Malaysia",
    emoji: "🇲🇾",
    unicode: "U+1F1F2 U+1F1FE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MY.svg",
    code: "MY",
    phoneCode: "+60",
  },
  {
    name: "Maldives",
    emoji: "🇲🇻",
    unicode: "U+1F1F2 U+1F1FB",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MV.svg",
    code: "MV",
    phoneCode: "+960",
  },
  {
    name: "Mali",
    emoji: "🇲🇱",
    unicode: "U+1F1F2 U+1F1F1",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ML.svg",
    code: "ML",
    phoneCode: "+223",
  },
  {
    name: "Malta",
    emoji: "🇲🇹",
    unicode: "U+1F1F2 U+1F1F9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MT.svg",
    code: "MT",
    phoneCode: "+356",
  },
  {
    name: "Marshall Islands",
    emoji: "🇲🇭",
    unicode: "U+1F1F2 U+1F1ED",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MH.svg",
    code: "MH",
    phoneCode: "+692",
  },
  {
    name: "Martinique",
    emoji: "🇲🇶",
    unicode: "U+1F1F2 U+1F1F6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MQ.svg",
    code: "MQ",
    phoneCode: "+596",
  },
  {
    name: "Mauritania",
    emoji: "🇲🇷",
    unicode: "U+1F1F2 U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MR.svg",
    code: "MR",
    phoneCode: "+222",
  },
  {
    name: "Mauritius",
    emoji: "🇲🇺",
    unicode: "U+1F1F2 U+1F1FA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MU.svg",
    code: "MU",
    phoneCode: "+230",
  },
  {
    name: "Mayotte",
    emoji: "🇾🇹",
    unicode: "U+1F1FE U+1F1F9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YT.svg",
    code: "YT",
    phoneCode: "+262",
  },
  {
    name: "Mexico",
    emoji: "🇲🇽",
    unicode: "U+1F1F2 U+1F1FD",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MX.svg",
    code: "MX",
    phoneCode: "+52",
  },
  {
    name: "Micronesia",
    emoji: "🇫🇲",
    unicode: "U+1F1EB U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FM.svg",
    code: "FM",
    phoneCode: "+691",
  },
  {
    name: "Moldova",
    emoji: "🇲🇩",
    unicode: "U+1F1F2 U+1F1E9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MD.svg",
    code: "MD",
    phoneCode: "+373",
  },
  {
    name: "Monaco",
    emoji: "🇲🇨",
    unicode: "U+1F1F2 U+1F1E8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MC.svg",
    code: "MC",
    phoneCode: "+377",
  },
  {
    name: "Mongolia",
    emoji: "🇲🇳",
    unicode: "U+1F1F2 U+1F1F3",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MN.svg",
    code: "MN",
    phoneCode: "+976",
  },
  {
    name: "Montenegro",
    emoji: "🇲🇪",
    unicode: "U+1F1F2 U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ME.svg",
    code: "ME",
    phoneCode: "+382",
  },
  {
    name: "Montserrat",
    emoji: "🇲🇸",
    unicode: "U+1F1F2 U+1F1F8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MS.svg",
    code: "MS",
    phoneCode: "+1664",
  },
  {
    name: "Morocco",
    emoji: "🇲🇦",
    unicode: "U+1F1F2 U+1F1E6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MA.svg",
    code: "MA",
    phoneCode: "+212",
  },
  {
    name: "Namibia",
    emoji: "🇳🇦",
    unicode: "U+1F1F3 U+1F1E6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NA.svg",
    code: "NA",
    phoneCode: "+264",
  },
  {
    name: "Nauru",
    emoji: "🇳🇷",
    unicode: "U+1F1F3 U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NR.svg",
    code: "NR",
    phoneCode: "+674",
  },
  {
    name: "Nepal",
    emoji: "🇳🇵",
    unicode: "U+1F1F3 U+1F1F5",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NP.svg",
    code: "NP",
    phoneCode: "+977",
  },
  {
    name: "Netherlands",
    emoji: "🇳🇱",
    unicode: "U+1F1F3 U+1F1F1",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NL.svg",
    code: "NL",
    phoneCode: "+31",
  },
  {
    name: "New Caledonia",
    emoji: "🇳🇨",
    unicode: "U+1F1F3 U+1F1E8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NC.svg",
    code: "NC",
    phoneCode: "+687",
  },
  {
    name: "New Zealand",
    emoji: "🇳🇿",
    unicode: "U+1F1F3 U+1F1FF",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NZ.svg",
    code: "NZ",
    phoneCode: "+64",
  },
  {
    name: "Nicaragua",
    emoji: "🇳🇮",
    unicode: "U+1F1F3 U+1F1EE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NI.svg",
    code: "NI",
    phoneCode: "+505",
  },
  {
    name: "Niger",
    emoji: "🇳🇪",
    unicode: "U+1F1F3 U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NE.svg",
    code: "NE",
    phoneCode: "+227",
  },
  {
    name: "Nigeria",
    emoji: "🇳🇬",
    unicode: "U+1F1F3 U+1F1EC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NG.svg",
    code: "NG",
    phoneCode: "+234",
  },
  {
    name: "Niue",
    emoji: "🇳🇺",
    unicode: "U+1F1F3 U+1F1FA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NU.svg",
    code: "NU",
    phoneCode: "+683",
  },
  {
    name: "Norfolk Island",
    emoji: "🇳🇫",
    unicode: "U+1F1F3 U+1F1EB",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NF.svg",
    code: "NF",
    phoneCode: "+672",
  },
  {
    name: "North Korea",
    emoji: "🇰🇵",
    unicode: "U+1F1F0 U+1F1F5",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KP.svg",
    code: "KP",
    phoneCode: "+850",
  },
  {
    name: "Northern Mariana Islands",
    emoji: "🇲🇵",
    unicode: "U+1F1F2 U+1F1F5",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MP.svg",
    code: "MP",
    phoneCode: "+1 670",
  },
  {
    name: "Norway",
    emoji: "🇳🇴",
    unicode: "U+1F1F3 U+1F1F4",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NO.svg",
    code: "NO",
    phoneCode: "+47",
  },
  {
    name: "Oman",
    emoji: "🇴🇲",
    unicode: "U+1F1F4 U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/OM.svg",
    code: "OM",
    phoneCode: "+968",
  },
  {
    name: "Pakistan",
    emoji: "🇵🇰",
    unicode: "U+1F1F5 U+1F1F0",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PK.svg",
    code: "PK",
    phoneCode: "+92",
  },
  {
    name: "Palau",
    emoji: "🇵🇼",
    unicode: "U+1F1F5 U+1F1FC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PW.svg",
    code: "PW",
    phoneCode: "+680",
  },
  {
    name: "Panama",
    emoji: "🇵🇦",
    unicode: "U+1F1F5 U+1F1E6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PA.svg",
    code: "PA",
    phoneCode: "+507",
  },
  {
    name: "Papua New Guinea",
    emoji: "🇵🇬",
    unicode: "U+1F1F5 U+1F1EC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PG.svg",
    code: "PG",
    phoneCode: "+675",
  },
  {
    name: "Paraguay",
    emoji: "🇵🇾",
    unicode: "U+1F1F5 U+1F1FE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PY.svg",
    code: "PY",
    phoneCode: "+595",
  },
  {
    name: "Peru",
    emoji: "🇵🇪",
    unicode: "U+1F1F5 U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PE.svg",
    code: "PE",
    phoneCode: "+51",
  },
  {
    name: "Philippines",
    emoji: "🇵🇭",
    unicode: "U+1F1F5 U+1F1ED",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PH.svg",
    code: "PH",
    phoneCode: "+63",
  },
  {
    name: "Poland",
    emoji: "🇵🇱",
    unicode: "U+1F1F5 U+1F1F1",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PL.svg",
    code: "PL",
    phoneCode: "+48",
  },
  {
    name: "Portugal",
    emoji: "🇵🇹",
    unicode: "U+1F1F5 U+1F1F9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PT.svg",
    code: "PT",
    phoneCode: "+351",
  },
  {
    name: "Puerto Rico",
    emoji: "🇵🇷",
    unicode: "U+1F1F5 U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PR.svg",
    code: "PR",
    phoneCode: "+1 787",
  },
  {
    name: "Qatar",
    emoji: "🇶🇦",
    unicode: "U+1F1F6 U+1F1E6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/QA.svg",
    code: "QA",
    phoneCode: "+974",
  },
  {
    name: "Romania",
    emoji: "🇷🇴",
    unicode: "U+1F1F7 U+1F1F4",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RO.svg",
    code: "RO",
    phoneCode: "+40",
  },
  {
    name: "Russia",
    emoji: "🇷🇺",
    unicode: "U+1F1F7 U+1F1FA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RU.svg",
    code: "RU",
    phoneCode: "+7",
  },
  {
    name: "Rwanda",
    emoji: "🇷🇼",
    unicode: "U+1F1F7 U+1F1FC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RW.svg",
    code: "RW",
    phoneCode: "+250",
  },
  {
    name: "Samoa",
    emoji: "🇼🇸",
    unicode: "U+1F1FC U+1F1F8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WS.svg",
    code: "WS",
    phoneCode: "+685",
  },
  {
    name: "San Marino",
    emoji: "🇸🇲",
    unicode: "U+1F1F8 U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SM.svg",
    code: "SM",
    phoneCode: "+378",
  },
  {
    name: "Saudi Arabia",
    emoji: "🇸🇦",
    unicode: "U+1F1F8 U+1F1E6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SA.svg",
    code: "SA",
    phoneCode: "+966",
  },
  {
    name: "Senegal",
    emoji: "🇸🇳",
    unicode: "U+1F1F8 U+1F1F3",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SN.svg",
    code: "SN",
    phoneCode: "+221",
  },
  {
    name: "Serbia",
    emoji: "🇷🇸",
    unicode: "U+1F1F7 U+1F1F8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RS.svg",
    code: "RS",
    phoneCode: "+381",
  },
  {
    name: "Seychelles",
    emoji: "🇸🇨",
    unicode: "U+1F1F8 U+1F1E8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SC.svg",
    code: "SC",
    phoneCode: "+248",
  },
  {
    name: "Sierra Leone",
    emoji: "🇸🇱",
    unicode: "U+1F1F8 U+1F1F1",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SL.svg",
    code: "SL",
    phoneCode: "+232",
  },
  {
    name: "Singapore",
    emoji: "🇸🇬",
    unicode: "U+1F1F8 U+1F1EC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SG.svg",
    code: "SG",
    phoneCode: "+65",
  },
  {
    name: "Slovakia",
    emoji: "🇸🇰",
    unicode: "U+1F1F8 U+1F1F0",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SK.svg",
    code: "SK",
    phoneCode: "+421",
  },
  {
    name: "Slovenia",
    emoji: "🇸🇮",
    unicode: "U+1F1F8 U+1F1EE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SI.svg",
    code: "SI",
    phoneCode: "+386",
  },
  {
    name: "Solomon Islands",
    emoji: "🇸🇧",
    unicode: "U+1F1F8 U+1F1E7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SB.svg",
    code: "SB",
    phoneCode: "+677",
  },
  {
    name: "South Africa",
    emoji: "🇿🇦",
    unicode: "U+1F1FF U+1F1E6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZA.svg",
    code: "ZA",
    phoneCode: "+27",
  },
  {
    name: "South Korea",
    emoji: "🇰🇷",
    unicode: "U+1F1F0 U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KR.svg",
    code: "KR",
    phoneCode: "+82",
  },
  {
    name: "Spain",
    emoji: "🇪🇸",
    unicode: "U+1F1EA U+1F1F8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ES.svg",
    code: "ES",
    phoneCode: "+34",
  },
  {
    name: "Sri Lanka",
    emoji: "🇱🇰",
    unicode: "U+1F1F1 U+1F1F0",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LK.svg",
    code: "LK",
    phoneCode: "+94",
  },
  {
    name: "Sudan",
    emoji: "🇸🇩",
    unicode: "U+1F1F8 U+1F1E9",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SD.svg",
    code: "SD",
    phoneCode: "+249",
  },
  {
    name: "Suriname",
    emoji: "🇸🇷",
    unicode: "U+1F1F8 U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SR.svg",
    code: "SR",
    phoneCode: "+597",
  },
  {
    name: "Sweden",
    emoji: "🇸🇪",
    unicode: "U+1F1F8 U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SE.svg",
    code: "SE",
    phoneCode: "+46",
  },
  {
    name: "Switzerland",
    emoji: "🇨🇭",
    unicode: "U+1F1E8 U+1F1ED",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CH.svg",
    code: "CH",
    phoneCode: "+41",
  },
  {
    name: "Syria",
    emoji: "🇸🇾",
    unicode: "U+1F1F8 U+1F1FE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SY.svg",
    code: "SY",
    phoneCode: "+963",
  },
  {
    name: "Taiwan",
    emoji: "🇹🇼",
    unicode: "U+1F1F9 U+1F1FC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TW.svg",
    code: "TW",
    phoneCode: "+886",
  },
  {
    name: "Tajikistan",
    emoji: "🇹🇯",
    unicode: "U+1F1F9 U+1F1EF",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TJ.svg",
    code: "TJ",
    phoneCode: "+992",
  },
  {
    name: "Tanzania",
    emoji: "🇹🇿",
    unicode: "U+1F1F9 U+1F1FF",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TZ.svg",
    code: "TZ",
    phoneCode: "+255",
  },
  {
    name: "Thailand",
    emoji: "🇹🇭",
    unicode: "U+1F1F9 U+1F1ED",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TH.svg",
    code: "TH",
    phoneCode: "+66",
  },
  {
    name: "Togo",
    emoji: "🇹🇬",
    unicode: "U+1F1F9 U+1F1EC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TG.svg",
    code: "TG",
    phoneCode: "+228",
  },
  {
    name: "Tokelau",
    emoji: "🇹🇰",
    unicode: "U+1F1F9 U+1F1F0",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TK.svg",
    code: "TK",
    phoneCode: "+690",
  },
  {
    name: "Tonga",
    emoji: "🇹🇴",
    unicode: "U+1F1F9 U+1F1F4",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TO.svg",
    code: "TO",
    phoneCode: "+676",
  },
  {
    name: "Tunisia",
    emoji: "🇹🇳",
    unicode: "U+1F1F9 U+1F1F3",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TN.svg",
    code: "TN",
    phoneCode: "+216",
  },
  {
    name: "Turkey",
    emoji: "🇹🇷",
    unicode: "U+1F1F9 U+1F1F7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TR.svg",
    code: "TR",
    phoneCode: "+90",
  },
  {
    name: "Turkmenistan",
    emoji: "🇹🇲",
    unicode: "U+1F1F9 U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TM.svg",
    code: "TM",
    phoneCode: "+993",
  },
  {
    name: "Tuvalu",
    emoji: "🇹🇻",
    unicode: "U+1F1F9 U+1F1FB",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TV.svg",
    code: "TV",
    phoneCode: "+688",
  },
  {
    name: "U.S. Virgin Islands",
    emoji: "🇻🇮",
    unicode: "U+1F1FB U+1F1EE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VI.svg",
    code: "VI",
    phoneCode: "+1 340",
  },
  {
    name: "Uganda",
    emoji: "🇺🇬",
    unicode: "U+1F1FA U+1F1EC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UG.svg",
    code: "UG",
    phoneCode: "+256",
  },
  {
    name: "Ukraine",
    emoji: "🇺🇦",
    unicode: "U+1F1FA U+1F1E6",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UA.svg",
    code: "UA",
    phoneCode: "+380",
  },
  {
    name: "United Arab Emirates",
    emoji: "🇦🇪",
    unicode: "U+1F1E6 U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AE.svg",
    code: "AE",
    phoneCode: "+971",
  },
  {
    name: "United Kingdom",
    emoji: "🇬🇧",
    unicode: "U+1F1EC U+1F1E7",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GB.svg",
    code: "GB",
    phoneCode: "+44",
  },
  {
    name: "United States",
    emoji: "🇺🇸",
    unicode: "U+1F1FA U+1F1F8",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/US.svg",
    code: "US",
    phoneCode: "+1",
  },
  {
    name: "Uruguay",
    emoji: "🇺🇾",
    unicode: "U+1F1FA U+1F1FE",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UY.svg",
    code: "UY",
    phoneCode: "+598",
  },
  {
    name: "Uzbekistan",
    emoji: "🇺🇿",
    unicode: "U+1F1FA U+1F1FF",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UZ.svg",
    code: "UZ",
    phoneCode: "+998",
  },
  {
    name: "Vanuatu",
    emoji: "🇻🇺",
    unicode: "U+1F1FB U+1F1FA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VU.svg",
    code: "VU",
    phoneCode: "+678",
  },
  {
    name: "Venezuela",
    emoji: "🇻🇪",
    unicode: "U+1F1FB U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VE.svg",
    code: "VE",
    phoneCode: "+58",
  },
  {
    name: "Vietnam",
    emoji: "🇻🇳",
    unicode: "U+1F1FB U+1F1F3",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VN.svg",
    code: "VN",
    phoneCode: "+84",
  },
  {
    name: "Yemen",
    emoji: "🇾🇪",
    unicode: "U+1F1FE U+1F1EA",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YE.svg",
    code: "YE",
    phoneCode: "+967",
  },
  {
    name: "Zambia",
    emoji: "🇿🇲",
    unicode: "U+1F1FF U+1F1F2",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZM.svg",
    code: "ZM",
    phoneCode: "+260",
  },
  {
    name: "Zimbabwe",
    emoji: "🇿🇼",
    unicode: "U+1F1FF U+1F1FC",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZW.svg",
    code: "ZW",
    phoneCode: "+263",
  },
];

export const breakpoints = {
  xs: 320,
  sm: 576,
  md: 960,
  lg: 1600,
};

export const availabilityCalendar = {
  ARIA_LABEL_FORMAT: "dddd, LL",
  BLOCKED_MODIFIER: "blocked",
  BOTTOM_CONTROLS_INSET_PX: 34,
  CALENDAR_DAY_SPACING: 2,
  CalendarDayTooltipAlign: { LEFT: "left", CENTER: "center", RIGHT: "right" },
  CalendarInfoPosition: {
    INFO_POSITION_TOP: "top",
    INFO_POSITION_BOTTOM: "bottom",
    INFO_POSITION_BEFORE: "before",
    INFO_POSITION_AFTER: "after",
  },
  CalendarNavigationDirection: { 0: "NEXT", 1: "PREV", NEXT: 0, PREV: 1 },
  CalendarOrientation: {
    HORIZONTAL: "horizontal",
    VERTICAL: "vertical",
    VERTICAL_SCROLLABLE: "verticalScrollable",
  },
  DAYS: "days",
  DEFAULT_CALENDAR_DAY_SIZE: 44,
  DEFAULT_NUMBER_OF_MONTHS: 1,
  DEFAULT_NUMBER_OF_MONTHS_VERTICAL: 4,
  DISPLAY_FORMAT: "L",
  FocusedInput: { START_DATE: "startDate", END_DATE: "endDate" },
  GUEST_CALENDAR_MAX_DATE_MONTH_ADDITION: 23,
  ISO_FORMAT: "YYYY-MM-DD",
  IconPosition: {
    ICON_BEFORE_POSITION: "before",
    ICON_AFTER_POSITION: "after",
  },
  MODIFIER_KEY_NAMES: new Set(["Shift", "Control", "Alt", "Meta"]),
  MONTH: "month",
  MONTHS: "months",
  NUM_WEEK_DAYS: 7,
  NavPosition: {
    NAV_POSITION_BOTTOM: "navPositionBottom",
    NAV_POSITION_TOP: "navPositionTop",
  },
  OpenDirection: { OPEN_DOWN: "down", OPEN_UP: "up" },
  REACT_DATES_PADDING: 26,
  UNICODE_LETTERS_REGEX:
    /[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0345\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C83\u1C85-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/i,
  VERTICAL_BORDER_SPACING: 2,
  WEEKDAYS: [0, 1, 2, 3, 4, 5, 6],
  YEARS: "years",
};

export const LAST_USED_LOCATION_STORAGE_KEY = "last-used-location";

export const POPULAR_LOCATIONS_US = [
  {
    label: "Los Angeles Recreation & Parks",
    value: {
      place_id: "ChIJCUfRYL3AwoARJfrTZF9BVJA",
      formatted_address: "Los Angeles Recreation & Parks",
      geometry: {
        location: {
          lat: 34.11850640000001,
          lng: -118.2861259,
        },
      },
      address_components: [
        { long_name: "90027", short_name: "90027", types: ["postal_code"] },
        {
          long_name: "1210",
          short_name: "1210",
          types: ["postal_code_suffix"],
        },
      ],
    },
    lat: 34.11850640000001,
    lng: -118.2861259,
    postalCode: "90027",
  },
  {
    label: "Glendale Park",
    value: {
      place_id:
        "EidQYXJrIFBsLCBMYSBDcmVzY2VudGEtTW9udHJvc2UsIENBLCBVU0EiLiosChQKEgmLD0ILDurCgBHiOs5y5x8zCxIUChIJ53T5_RTqwoARhU0PK-ZUGrk",
      formatted_address: "Glendale Park",
      geometry: {
        location: {
          lat: 34.1335039,
          lng: -118.2408553,
        },
      },
    },
    lat: 34.1335039,
    lng: -118.2408553,
    postalCode: "91205",
  },
  {
    label: "Whistle Country Club",
    value: {
      place_id: "ChIJT7Tv5HO8woARk65ek82BaEA",
      formatted_address: "10101 Wilshire Blvd, Los Angeles, CA 90024, USA",
      geometry: {
        location: {
          lat: 34.0694313,
          lng: -118.4232896,
        },
      },
    },
    lat: 34.0694313,
    lng: -118.4232896,
    postalCode: "90024",
  },
];

export const POPULAR_LOCATIONS_UK = [
  {
    label: "Hyde Park",
    value: {
      place_id: "ChIJlVkfb0gFdkgRpqIbSkkFdkg",
      formatted_address: "Serpentine Galleries Hyde Park, LONDON W2 2UH",
      geometry: {
        location: {
          lat: 51.507998,
          lng: -0.166276,
        },
      },
      address_components: [
        {
          long_name: "W2 2UH",
          short_name: "W2 2UH",
          types: ["postal_code"],
        },
      ],
    },
    lat: 51.507998,
    lng: -0.166276,
    postalCode: "W2 2UH",
  },
  {
    label: "Battersea Park",
    value: {
      place_id: "ChIJOWBQvA4FdkgRQf5iYYFF1v4",
      formatted_address: "Battersea Park, LONDON SW11 4NJ",
      geometry: {
        location: {
          lat: 51.4801815,
          lng: -0.1557024,
        },
      },
      address_components: [
        {
          long_name: "SW11 4NJ",
          short_name: "SW11 4NJ",
          types: ["postal_code"],
        },
      ],
    },
    lat: 51.4801815,
    lng: -0.1557024,
    postalCode: "SW11 4NJ",
  },
  {
    label: "St. James's Park",
    value: {
      place_id: "ChIJG-CxwNoEdkgRXx26gHZwVf8",
      formatted_address: "St. James's Park, LONDON SW1A 2BJ",
      geometry: {
        location: {
          lat: 51.503031,
          lng: -0.130209,
        },
      },
      address_components: [
        {
          long_name: "SW1A 2BJ",
          short_name: "SW1A 2BJ",
          types: ["postal_code"],
        },
      ],
    },
    lat: 51.503031,
    lng: -0.130209,
    postalCode: "90024",
  },
];

export const POPULAR_LOCATIONS = (region) =>
  region /*process.env.REACT_APP_REGION*/ === "GB"
    ? POPULAR_LOCATIONS_UK
    : POPULAR_LOCATIONS_US;

export const LOCATION_PICKER_RECENT_LOCATIONS = {
  STORAGE_KEY: "recent-locations",
  MAX_COUNT: 20,
  LIST_COUNT_DESKTOP: 3,
  LIST_COUNT_MOBILE: 3,
  ELIGIBLE_FREQUENCY: 2,
};

// Custom styles for modals
export const modalStyles = {
  default: {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      overflow: "auto",
      zIndex: "997", // more than header's and sidebar's z-index (996)
    },
    content: {
      width: "480px",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      border: "none",
      borderRadius: "16px",
      transform: "translate(-50%, -50%)",
      padding: "24px",
      overflow: "visible",
    },
  },
  get mobileDefault() {
    return Object.assign(
      {},
      { ...this.default },
      {
        overlay: {
          ...this.default.overlay,
          backgroundColor: "rgb(0,0,0,.1)",
          zIndex: "1050", // Slightly above header
        },
        content: {
          ...this.default.content,
          width: "100%",
          top: "48px",
          left: "0",
          right: "0",
          bottom: "0",
          borderRadius: "16px",
          transform: "translate(0, 0)",
          padding: "0",
          boxShadow: "0 4px 20px 0 rgba(0,0,0,.1)",
        },
      }
    );
  },
  get newMobileDefault() {
    return Object.assign(
      {},
      { ...this.default },
      {
        overlay: {
          ...this.default.overlay,
          backgroundColor: "rgb(0,0,0,.1)",
          zIndex: "1050", // Slightly above header
        },
        content: {
          ...this.default.content,
          width: "100%",
          top: "48px",
          left: "0",
          right: "0",
          bottom: "0",
          borderRadius: "8px",
          transform: "translate(0, 0)",
          padding: "0",
          boxShadow: "0 4px 20px 0 rgba(0,0,0,.1)",
        },
      }
    );
  },
  get info() {
    return Object.assign(
      {},
      { ...this.default },
      {
        overlay: {
          ...this.default.overlay,
          zIndex: "1080", // To be above Add Card Modal
        },
        content: {
          ...this.default.content,
          width: "420px",
        },
      }
    );
  },
  get infoMobile() {
    return Object.assign(
      {},
      { ...this.default },
      {
        overlay: {
          ...this.default.overlay,
          zIndex: "1080", // To be above Add Card Modal
        },
        content: {
          ...this.default.content,
          width: "320px",
        },
      }
    );
  },
  get error() {
    return Object.assign(
      {},
      { ...this.default },
      {
        content: {
          ...this.default.content,
          transition: "all .6s ease",
        },
      }
    );
  },
  get dialog() {
    return Object.assign(
      {},
      { ...this.default },
      {
        content: {
          ...this.default.content,
          padding: "30px",
        },
      }
    );
  },
  get reviewsModal() {
    return Object.assign(
      {},
      { ...this.default },
      {
        overlay: {
          ...this.default.overlay,
          zIndex: "1080",
        },
        content: {
          ...this.default.content,
          top: "auto",
          width: "584px",
          transform: "translate(-50%, 0)",
          marginTop: "56px",
          marginBottom: "56px",
        },
      }
    );
  },
  get cookiePopup() {
    return Object.assign(
      {},
      { ...this.default },
      {
        overlay: {
          ...this.default.overlay,
          // backgroundColor       : '#797979',
          zIndex: "1050", // Slightly above header
        },
        content: {
          ...this.default.content,
          width: "536px",
          top: "50%", // '80px',
          left: "50%",
          right: "auto",
          bottom: "auto",
          backgroundColor: "rbg(0, 0, 0)",
          borderRadius: "8px",
          transform: "translate(-50%, -50%)",
          padding: "0",
          boxShadow: "0 4px 20px 0 rgba(0,0,0,.1)",
        },
      }
    );
  },
  get cookiePopupMobile() {
    return Object.assign(
      {},
      { ...this.default },
      {
        overlay: {
          ...this.default.overlay,
          // backgroundColor       : '#797979',
          zIndex: "1050", // Slightly above header
        },
        content: {
          ...this.default.content,
          width: "auto",
          top: "50%", // '80px',
          left: "20px",
          right: "20px",
          bottom: "auto",
          backgroundColor: "rbg(0, 0, 0)",
          borderRadius: "8px",
          transform: "translate(0, -50%)",
          padding: "0",
          boxShadow: "0 4px 20px 0 rgba(0,0,0,.1)",
        },
      }
    );
  },
  get galleryCarouselDefault() {
    return Object.assign(
      {},
      { ...this.default },
      {
        overlay: {
          ...this.default.overlay,
          // backgroundColor       : '#797979',
          zIndex: "1050", // Slightly above header
        },
        content: {
          ...this.default.content,
          width: "100%",
          top: "0", // '80px',
          left: "0",
          right: "0",
          bottom: "0",
          backgroundColor: "transparent",
          borderRadius: "0",
          transform: "translate(0, 0)",
          padding: "0",
          boxShadow: "0 4px 20px 0 rgba(0,0,0,.1)",
        },
      }
    );
  },
};

export const cardFormOptions = {
  fonts: [
    {
      family: "museo_sans_rounded",
      src: 'url("https://static.trubeapp.com/live/assets/webpack/4c53ae5b572019d0a97f7e95401836b1.woff2") format("woff2")',
      style: "normal",
      weight: 300,
    },
  ],
};

export const elementOptions = {
  style: {
    base: {
      fontSize: "16px",
      color: "#203b54",
      fontFamily: "Poppins, sans-serif",
      fontWeight: 400,
      lineHeight: "26px",
      // letterSpacing: '0.025em',
      "::placeholder": {
        color: "#cbcfd5",
      },
    },
    invalid: {
      color: "#ff7557",
    },
  },
};

/* Facebook events */
export const FB_EVENT_COMPLETE_REGISTRATION = "CompleteRegistration";
export const FB_EVENT_PURCHASE = "Purchase";
